import { combineReducers } from 'redux'

import list from './list'
import detail from './detail'
import listings from './listings'

export default combineReducers({
  list, detail, listings
})
